const ArticleList = () => import('../../views/article/ArticleList.vue');
const ArticleEdit = () => import('../../views/article/ArticleEdit.vue');
const ArticleClassList = () => import('../../views/article/ArticleClassList.vue');
const ArticleClassEdit = () => import('../../views/article/ArticleClassEdit.vue');
const ArticleByClassList = () => import('../../views/article/ArticleByClassList.vue');
const TipsClassList = () => import('../../views/article/TipsClassList.vue');
const TipsClassEdit = () => import('../../views/article/TipsClassEdit.vue');
const ArticleByTipsList = () => import('../../views/article/ArticleByTipsList.vue');

const Container = {
  template: `
    <div class="Container">
      <router-view></router-view>
    </div>
  `,
};

const router = {
  path: '/article/productList',
  name: 'ArticleContainer',
  component: Container,
  meta: {
    title: '文章管理',
    icon: 'notebook-2',
  },
  children: [
    {
      path: '/article/articleList',
      name: 'ArticleListContainer',
      component: Container,
      meta: {
        title: '文章素材库',
        hideChildren: true,
      },
      children: [
        {
          path: '',
          name: 'ArticleList',
          component: ArticleList,
          meta: {
            title: '文章列表',
          },
        },
        {
          path: '/article/articleAdd',
          name: 'ArticleAdd',
          component: ArticleEdit,
          meta: {
            title: '文章新增',
            light: '/article/articleList',
          },
        },
        {
          path: '/article/articleEdit/:articleId',
          name: 'ArticleEdit',
          component: ArticleEdit,
          meta: {
            title: '文章编辑',
            light: '/article/articleList',
          },
        },
      ],
    },
    {
      path: '/article/articleClassList',
      name: 'ArticleClassListContainer',
      component: Container,
      meta: {
        title: '科普文章分类',
        hideChildren: true,
      },
      children: [
        {
          path: '',
          name: 'ArticleClassList',
          component: ArticleClassList,
          meta: {
            title: '科普文章分类列表',
          },
        },
        {
          path: '/article/articleClassAdd',
          name: 'ArticleClassAdd',
          component: ArticleClassEdit,
          meta: {
            title: '科普文章分类新增',
            light: '/article/articleClassList',
          },
        },
        {
          path: '/article/articleClassEdit/:classId',
          name: 'ArticleClassEdit',
          component: ArticleClassEdit,
          meta: {
            title: '科普文章分类编辑',
            light: '/article/articleClassList',
          },
        },
      ],
    },
    {
      path: '/article/articleByClassList',
      name: 'ArticleByClassListContainer',
      component: Container,
      meta: {
        title: '科普文章列表',
        hideChildren: true,
      },
      children: [
        {
          path: '',
          name: 'ArticleByClassList',
          component: ArticleByClassList,
          meta: {
            title: '科普文章列表',
            light: '/article/articleByClassList',
          },
        },
      ],
    },
    {
      path: '/article/tipsClassList',
      name: 'TipsClassListContainer',
      component: Container,
      meta: {
        title: '攻略文章分类',
        hideChildren: true,
      },
      children: [
        {
          path: '',
          name: 'TipsClassList',
          component: TipsClassList,
          meta: {
            title: '攻略文章分类列表',
          },
        },
        {
          path: '/article/tipsClassAdd',
          name: 'TipsClassAdd',
          component: TipsClassEdit,
          meta: {
            title: '攻略文章分类新增',
            light: '/article/tipsClassList',
          },
        },
        {
          path: '/article/tipsClassEdit/:classId',
          name: 'TipsClassEdit',
          component: TipsClassEdit,
          meta: {
            title: '攻略文章分类编辑',
            light: '/article/tipsClassList',
          },
        },
      ],
    },
    {
      path: '/article/articleByTipsList',
      name: 'ArticleByTipsListContainer',
      component: Container,
      meta: {
        title: '攻略文章列表',
        hideChildren: true,
      },
      children: [
        {
          path: '',
          name: 'ArticleByTipsList',
          component: ArticleByTipsList,
          meta: {
            title: '攻略文章列表',
            light: '/article/articleByTipsList',
          },
        },
      ],
    },
  ],
};
export default router;



// WEBPACK FOOTER //
// ./src/router/modules/article.js